import { render } from "./AddToCollectionPopup.vue?vue&type=template&id=00feee1a&scoped=true"
import script from "./AddToCollectionPopup.vue?vue&type=script&lang=js"
export * from "./AddToCollectionPopup.vue?vue&type=script&lang=js"

import "./AddToCollectionPopup.vue?vue&type=style&index=0&id=00feee1a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00feee1a"]])

export default __exports__